/*
 *  I04CONCLIMCONSI18n.js
 *
 *  Created by Sébastien Hecart on 2018-04-01 12:38:50 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I04CONCLIMCONS_SECTION_0_TITLE:
    "Faites le suivi de vos consommations à climat constant pour mieux appréhender votre gestion de l'énergie.",
  I04CONCLIMCONS_in_djureference: 'DJU de référence',
  I04CONCLIMCONS_dju_uuid_ville: 'Ville DJU de référence',
  I04CONCLIMCONS_in_nombreAnnee: "Nombre d'année souhaité",
  I04CONCLIMCONS_in_conso: 'Consommation année',
  I04CONCLIMCONS_in_conso_mail: 'Consommation',
  I04CONCLIMCONS_in_annee: 'Année',
  I04CONCLIMCONS_in_djus: 'Nombre DJU',
  I04CONCLIMCONS_res_conso: 'Conso à climat constant'
}
